const data = {
  id: 1,
  title: 'Listen and find the missing letters.',
  subTitle: 'Nghe và điền vào chỗ trống.',
  question: 'b_a_',
  answers: 'bear',
  // filterVowels: false,
  // settings: {
  //   answers: {
  //     randomNumbers: 2,
  //   },
  // },
  audioUrl: 'https://cloud.softech.cloud/storage/Data/Sentences/11c5fedf-cd9e-426b-810f-85aaba584272.mp3',
};

export default data;
